import './input-click'
import './input-drag'
import './input-hold'
import './input-swipe'
import './input-wheel'
import './progress'
import './render-360'
import './render-blur'
import './render-ease'
import './render-gallery'
import './render-panorama'
import './render-zoom'
